export default ({ listing = {}, content = {} }) => {
    return [listing.response && listing.response.headers, content.response && content.response.headers].filter((responseHeaders) => !!responseHeaders);
};
